import React from 'react'

import type Immutable from 'immutable'
import { useDispatch, useSelector } from 'react-redux'

import { SignupMotivations } from '@features/signup-motivations'
import type { Motivations } from '@library/api-motivations/src/types'

import { signupSetSignupMotivations } from 'routes/Signup/signupActions'
import { getSignupMotivations } from 'routes/Signup/signupSelectors'

type SignupMotivationsStepProps = {
  next: () => void
  motivations: Motivations[]
}

export const SignupMotivationsStep = ({ next: _next, motivations }: SignupMotivationsStepProps) => {
  const dispatch = useDispatch()
  const signupMotivations: Immutable.List<string> = useSelector(getSignupMotivations)

  const handleSkipCTAClick = (dietaryPreferencesChange: Immutable.List<string>) => {
    dispatch(signupSetSignupMotivations(dietaryPreferencesChange))
    _next()
  }

  const handleContinueCTAClick = (dietaryPreferencesChange: Immutable.List<string>) => {
    dispatch(signupSetSignupMotivations(dietaryPreferencesChange))
    _next()
  }

  return (
    <SignupMotivations
      onContinue={handleContinueCTAClick}
      onSkip={handleSkipCTAClick}
      defaultSignupMotivations={signupMotivations}
      motivations={motivations}
    />
  )
}
